var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-link",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
        "data-toggle-second": "tooltip",
        "data-placement": "top",
        title: _vm.$translate("OD3dprimaV2::Template.wishlistTooltip"),
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "badge-right mr-1",
          class: { "d-none": _vm.wishListCount === 0 },
        },
        [_vm._v("\n        " + _vm._s(_vm.wishListCount) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "18",
          },
        },
        [
          _c("use", {
            attrs: {
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "xlink:href": "#svg-wishlist",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }